<template>
    <v-dialog
      content-class="dialog-custom"
      persistent
      v-model="dialog"
    >
        <div class = "planContainer">
            <div class="backButtonOne" v-if = "(step > 1 && step <= 3 && investStep === true) || (step > 1 && step < 3 && withdrawStep === true)">
                <img class = "back_image" src = "/img/arrow_back.svg" @click="goBack"/>
            </div>
          <div class = "closeContainer" v-show = "step >= 1">
            <v-btn class="mx-2" icon title="Close Form" @click="handleDialogClose">
              <v-icon class="material-icons-round"> close </v-icon>
            </v-btn>
          </div>
        </div>
        <div class = "screenContainer">
            <firstInvestScreen
                v-if = "step === 1"
                :incomeAmount = "incomeAmount"
                :escrowAmount = "escrowBalance"
                @withdrawCalled="withdrawCalled"
                @investCalled="investCalled"
            />
            <withdrawScreen
                v-if = "step >= 2 && withdrawStep === true"
                :step = "step"
                :incomeAmount = "incomeAmount"
                :escrowBalance = "escrowBalance"
                :withdrawType="withdrawType"
                @handleDialogClose="handleDialogClose"
                @success="success"
            />
            <investScreen
                v-if = "step >= 2 && investStep === true"
                :step = "step"
                :incomeAmount = "incomeAmount"
                :escrowBalance = "escrowBalance"
                :isEscrow = "isEscrow"
                :isMonthly = "isMonthly"
                @handleDialogClose="handleDialogClose"
                @success="success"
            />
        </div>
    </v-dialog>
  </template>
<script>
import firstInvestScreen from '@/components/common/escrowWalletFirstScreen.vue'
import withdrawScreen from '@/components/common/withdrawScreen.vue'
import investScreen from '@/components/common/investScreen.vue'
export default {
    name: 'escrowInvestDialog',
    components: {
        firstInvestScreen,
        withdrawScreen,
        investScreen
    },
    props: {
        showEscrowWalletDialog: Boolean,
        escrowBalance: Number,
        incomeAmount: Number
    },
    data () {
        return {
            step: 1,
            dialog: this.showEscrowWalletDialog,
            withdrawStep: false,
            investStep: false,
            isEscrow: false,
            isMonthly: false,
            withdrawType: ''
        }
    },
    methods: {
        goBack () {
            if (this.step === 2) {
                this.withdrawStep = false
                this.investStep = false
                this.isEscrow = false
                this.isMonthly = false
            }
            this.step--
        },
        handleDialogClose () {
            this.$emit('closeDialog')
        },
        withdrawCalled (withdrawType) {
            this.withdrawStep = true
            this.withdrawType = withdrawType
            this.step++
        },
        investCalled (isEscrow, isMonthly) {
            this.isEscrow = isEscrow
            this.isMonthly = isMonthly
            this.investStep = true
            this.step++
        },
        success () {
            this.step++
        }
    }
}
</script>
  <style lang="scss" scoped>
  @import "~@/sass/components/registration-flow.scss";
  @import "@/components/dashboard/dashboard.scss";

    .back_image {
        margin-left: 15px;
        margin-top: 2px;
        cursor: pointer
    }
    ::v-deep .v-dialog:not(.v-dialog--fullscreen) {
        height: 480px;
        display: flex;
        flex-direction: column;
      }
    .screenContainer {
        flex:1;
        height: initial;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
  hr {
    border: 0;
    clear:both;
    display:block;
    width: 96%;
    background-color:#e0e0e0;
    height: 1px;
  }
  .closeContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
  }
  .amountText {
      font-size: 17px;
      color: #002fa7;
      font-weight: 500;
  }
  .planTypeText {
      text-transform: capitalize;
      font-size: 17px;
      color: #232323;
      font-weight: 500;
      width: 100%
  }
  .backButtonContainer {
      margin-top: 7px;
      margin-left: 16px
  }
  ::v-deep .v-dialog::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
  }
  ::v-deep .v-dialog {
        background-color: #ffffff;
      border-radius: 16px
  }
  .icons {
      font-size: 15px;
      color: #007aff
  }
  .tryAgainText {
      font-weight: 500;
      font-size: 13px;
      color: #8C8C8C;
  }
  .successfulText {
    font-size: 19px;
    padding-bottom: 15px;
    font-weight: 500;
    color: #002fa7;
    text-align: center;
  }
  .failureText {
    font-size: 21px;
    padding-top: 25px;
    font-weight: 700;
    color: #F21E1E;
    text-align: center;
  }
  .buttonContainer {
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .buttonCancel {
    height: 40px !important;
    background: #e0e0e0 !important;
    border-color: #e0e0e0 !important;
    font-size: 14px !important;
    color: #232323 !important;
    margin-right: 10px !important;
    width: 120px !important;
  }
  .amountConfirmation {
      color: #232323 !important;
      font-weight: 600
  }
  .confirmationText {
      text-align: center;
      color: #4f4f4f;
      font-size: 17px
  }
  .superContainer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
  }

  .columnContainer {
      width: 90%;
      display: flex;
      flex-direction: column;
  }

  .rowContainer {
      width: 100%;
      display: flex;
      flex-direction: row;
  }
  .errorText {
      color: #e45f5f !important;
      font-size: 12px;
  }

  ::placeholder {
      color: #e0e0e0
  }
  .inputContainer {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
  }
  .selectPlanContainer {
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
  }
  .planContainer {
      padding-top: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
  }
  .selectPlan {
      font-weight: 600;
      font-size: 17px;
      margin-left: 30px;
      margin-bottom: 0px;
  }
  ::v-deep .v-dialog {
      width: 600px !important;
  }
  .v-card__title {
    line-height: 24px;
    word-break: normal;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .dialog-custom {
    height: 120px !important;
    background: #ffffff;
    border: 1px solid #b9b9bb !important;
    box-sizing: border-box !important;
    border-radius: 21px !important;

  }

  .v-text-field .v-label {
    font-weight: bold !important;
  }
  .dialog-header-custom {
    width: 200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }

  .mainContainer {
      width: 100%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }

  input[type=number] {
    border: none;
    background-color: none;
    outline: 0;
    font-size: 25px;
  }

  input[type=number]:focus {
    border: none;
    background-color: none;
    outline: 0;
  }

  .escrowBalanceText {
      font-weight: 700;
      font-size: 21px;
      color: #232323;
  }

  .escrowBalanceStatic {
      line-height: 1.5;
      width: 90%;
      text-align: center;
      margin-bottom: 25px;
      font-weight: 400;
      font-size: 13px;
      color: #007aff;
  }

  .escrowBalance {
      margin-bottom: 30px;
      font-weight: 700;
      font-size: 30px;
      color: #232323;
  }

  .buttonSubmit {
      margin-bottom: 30px;
      height: 40px !important;
      font-size: 14px !important;
      width: 90% !important;
  }

  .buttonConfirm {
      height: 40px !important;
      font-size: 14px !important;
      width: 120px !important;
  }

  .loadingContainer {
      height: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .loader {
      padding-top: 200px;
      height: 42px !important;
      width: 42px !important;
      color: #007AFF;
  }

  .v-dialog > .v-card > .v-card__title {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
  }

  @media (max-width: 480px) {

    ::v-deep .v-dialog {
        border-radius: 16px 16px 0px 0px;
    }
      ::v-deep .v-dialog {
          width: 100% !important;
          margin: 5px !important;
          margin-top: 35px !important;
      }
      ::v-deep .v-card__title {
          padding: 0px
      }
      .v-dialog > .v-card > .v-card__title {
          padding-left: 0px !important;
          padding-right: 0px !important;
          padding-top: 0px !important;
          padding-bottom: 0px !important;
      }
      .escrowBalanceText {
          font-size: 21px;
          margin-bottom: 2px;
      }

      .escrowBalanceStatic {
          font-size: 13px;
          text-align: center !important;
      }

      .escrowBalance {
          font-size: 24px;
      }

      .mainContainer {
          padding: 13px;
      }

      ::v-deep .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 100% !important;
        height: -webkit-fill-available;
      }
      ::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
        height: -webkit-fill-available;
      }
      .selectPlan {
          margin-left: 20px !important
      }
      .selectPlanContainer {
          align-items: baseline !important;
      }
      .screenContainer {
        flex:0;
    }
  }
  </style>
